export default __webpack_public_path__ + "static/logzio-jaeger-fb0eb6e796442447fc02a335bdcfd82b.png";